import RemovePropertiesProvider from './RemovePropertiesProvider';

const data = {
  __init__: [ 'removePropertiesProvider' ],
  removePropertiesProvider: [ 'type', RemovePropertiesProvider ]
};

export default data;